export const GET_DASHBOARD_CATEGORY_METRICS_IN_PROGRESS =
  "GET_DASHBOARD_CATEGORY_METRICS_IN_PROGRESS";
export const GET_DASHBOARD_CATEGORY_METRICS_SUCCESS =
  "GET_DASHBOARD_CATEGORY_METRICS_SUCCESS";
export const GET_DASHBOARD_CATEGORY_METRICS_FAIL =
  "GET_DASHBOARD_CATEGORY_METRICS_FAIL";
